export enum LoadLogSource {
  WEB = 'WEB',
  MOBILE = 'MOBILE',
}
